import { memo } from "react";
import { FaGasPump, FaHeart } from "react-icons/fa";
import StatBar from "./StatBar";

interface StatItemProps {
  icon: React.ReactNode;
  label: string;
  value: number;
  barColorClass: string;
}

const StatItem = memo<StatItemProps>(
  ({ icon, label, value, barColorClass }) => (
    <div className="flex items-center gap-2.5">
      <div className="mt-0.5 flex-shrink-0">{icon}</div>
      <div className="min-w-[105px]">
        <div className="flex items-baseline gap-1.5 mb-1.5">
          <span className="text-white/55 text-[14px] tracking-wide">
            {label}
          </span>
          <span className="text-white text-[18px] font-semibold">{value}%</span>
        </div>
        <StatBar value={value} colorClass={barColorClass} className="w-full" />
      </div>
    </div>
  ),
);

StatItem.displayName = "StatItem";

interface CarStatsProps {
  fuel: number;
  health: number;
}

const CarStats = memo<CarStatsProps>(({ fuel, health }) => (
  <div className="flex items-center gap-8">
    <StatItem
      icon={<FaGasPump size={20} className="text-white/50" />}
      label="Fuel"
      value={fuel}
      barColorClass="bg-[#C3FF1F]"
    />
    <StatItem
      icon={<FaHeart size={20} className="text-red-500/80" />}
      label="Health"
      value={health}
      barColorClass="bg-[#FF1F1F]"
    />
  </div>
));

CarStats.displayName = "CarStats";
export default CarStats;
